import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Banknote, Clock, ShieldCheck, HeartHandshake } from 'lucide-react';
interface Feature {
  icon: React.ElementType;
  title: string;
  description: string;
}
const features: Feature[] = [{
  icon: Banknote,
  title: 'Flexible & Tax-Free',
  description: 'Choose payment amounts based on what you can afford — your home equity covers the rest. Plus, the funds you receive are tax-free.'
}, {
  icon: Clock,
  title: 'Funded in 48 Hours',
  description: "Unlock up to 80% of your property's value with approval and funding in as little as 48 hours — no lengthy bank delays."
}, {
  icon: ShieldCheck,
  title: 'No Credit Checks',
  description: "We focus on your home's equity and location, not your credit score or income — making our solutions accessible to all homeowners."
}, {
  icon: HeartHandshake,
  title: 'Dedicated Support',
  description: 'A mortgage advisor guides you through every step — no hidden fees, no surprises, just straightforward lending.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function ProcessSteps() {
  return <section className="w-full relative overflow-hidden bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-290">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 80% at 80% 20%, rgba(201,169,97,0.15) 0%, rgba(201,169,97,0.06) 40%, transparent 70%)'
    }} aria-hidden="true" data-id="element-291" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-292">
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-293">
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-5 font-[500]" data-id="element-294">
            Why EquityRich
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-295">
            First and second mortgages based on your equity and property
            location — simple, fast, and built around you.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-296">
          {features.map(feature => <motion.div key={feature.title} className="flex gap-5 bg-white/8 backdrop-blur-sm border border-white/12 rounded-2xl p-6 transition-all duration-300 hover:bg-white/12 hover:border-white/20" variants={itemVariants} data-id="element-297">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center" data-id="element-298">
                <feature.icon className="w-6 h-6 text-accent" strokeWidth={1.8} data-id="element-299" />
              </div>
              <div data-id="element-300">
                <h3 className="text-lg font-semibold text-white mb-1.5" data-id="element-301">
                  {feature.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-302">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}